import React from "react";
import { Card } from "react-bootstrap";
import { FiUsers } from "react-icons/fi";
import { BsFillInboxFill } from "react-icons/bs";
import { RiWallet3Line, RiArrowLeftRightLine } from "react-icons/ri";
import { MdRouter } from "react-icons/md";
import {
  isAdmin,
  isCustomer,
  isEngineer,
  isSupport,
  isSuperAdmin,
  isAccounts,
} from "../services/authService";
import { formatNumber } from "../services/util";

const DashboardBoxes = (props) => {
  const { customerData, adminData } = props;
  return (
    <div className="card">
      <h5 className="card-header main-color-bg">Dashboard</h5>
      <div className="card-body">
        <span className="card-text">
          <div className="row">
            {isAdmin() && (
              <React.Fragment>
                <div className="col-md-4">
                  <Card
                    bg={"success"}
                    text={"white"}
                    className="mb-2 dashboard-box"
                  >
                    <Card.Body>
                      <h2>
                        <FiUsers className="mr-3 mb-2" />
                        {0 || formatNumber(adminData.leadCount)}
                      </h2>
                      <h4>Leads(s)</h4>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-md-4">
                  <Card
                    bg={"success"}
                    text={"white"}
                    className="mb-2 dashboard-box"
                  >
                    <Card.Body>
                      <h2>
                        <FiUsers className="mr-3 mb-2" />
                        {0 || formatNumber(adminData.customerCount)}
                      </h2>
                      <h4>Customer(s)</h4>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-md-4">
                  <Card
                    bg={"danger"}
                    text={"white"}
                    className="mb-2 dashboard-box"
                  >
                    <Card.Body>
                      <h2>
                        <MdRouter className="mr-3 mb-2" />
                        {formatNumber(adminData.equipmentCount)}
                      </h2>
                      <h4>CPE(s)</h4>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-md-4">
                  <Card
                    bg={"secondary"}
                    text={"white"}
                    className="mb-2 dashboard-box"
                  >
                    <Card.Body>
                      <h2>
                        <MdRouter className="mr-3 mb-2" />
                        {formatNumber(adminData.activeServicesCount)}
                      </h2>
                      <h4>Active Services(s)</h4>
                    </Card.Body>
                  </Card>
                </div>
                {(isEngineer() || isSuperAdmin()) && (
                  <div className="col-md-4">
                    <Card
                      bg={"info"}
                      text={"white"}
                      className="mb-2 dashboard-box"
                    >
                      <Card.Body>
                        <h2>
                          <MdRouter className="mr-3 mb-2" />
                          {formatNumber(adminData.routerCount)}
                        </h2>
                        <h4>Router(s)</h4>
                      </Card.Body>
                    </Card>
                  </div>
                )}
                {(isEngineer() || isSuperAdmin()) && (
                  <div className="col-md-4">
                    <Card
                      bg={"warning"}
                      text={"white"}
                      className="mb-2 dashboard-box"
                    >
                      <Card.Body>
                        <h2>
                          <BsFillInboxFill className="mr-3 mb-2" />
                          {formatNumber(adminData.ponOLTCount)}
                        </h2>
                        <h4>PON OLT(s)</h4>
                      </Card.Body>
                    </Card>
                  </div>
                )}
                {(isAccounts() || isSupport() || isSuperAdmin()) && (
                  <div className="col-md-4">
                    <Card
                      bg={"primary"}
                      text={"white"}
                      className="mb-2 dashboard-box"
                    >
                      <Card.Body>
                        <h2>
                          <RiArrowLeftRightLine className="mr-3 mb-2" />
                          {formatNumber(adminData.pendingTransactionCount)}
                        </h2>
                        <h4>Pending Transaction(s)</h4>
                      </Card.Body>
                    </Card>
                  </div>
                )}
                {(isAccounts() ||
                  isSupport() ||
                  isEngineer() ||
                  isSuperAdmin()) && (
                  <div className="col-md-4">
                    <Card
                      bg={"warning"}
                      text={"white"}
                      className="mb-2 dashboard-box"
                    >
                      <Card.Body>
                        <h2>
                          <RiArrowLeftRightLine className="mr-3 mb-2" />
                          {formatNumber(adminData.onlineCustomersCount)}
                        </h2>
                        <h4>Online Customer(s)</h4>
                      </Card.Body>
                    </Card>
                  </div>
                )}
                {(isAccounts() || isSupport() || isSuperAdmin()) && (
                  <div className="col-md-4">
                    <Card
                      bg={"info"}
                      text={"white"}
                      className="mb-2 dashboard-box"
                    >
                      <Card.Body>
                        <h2>
                          <RiArrowLeftRightLine className="mr-3 mb-2" />
                          {formatNumber(adminData.pendingRenewalsCount)}
                        </h2>
                        <h4>Pending Renewal(s)</h4>
                      </Card.Body>
                    </Card>
                  </div>
                )}
              </React.Fragment>
            )}
            {isCustomer() && (
              <React.Fragment>
                <div className="col-md">
                  <Card
                    bg={"primary"}
                    text={"white"}
                    className="mb-2 dashboard-box"
                  >
                    <Card.Body>
                      <h2>
                        <RiWallet3Line className="mr-3 mb-2" />
                        &#8358;
                        {0.0 || formatNumber(customerData.accountBalance)}
                      </h2>
                      <h4>Account Balance</h4>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-md">
                  <Card
                    bg={"warning"}
                    text={"white"}
                    className="mb-2 dashboard-box"
                  >
                    <Card.Body>
                      <h2>
                        <MdRouter className="mr-3 mb-2" />
                        {0 || formatNumber(customerData.equipmentCount)}
                      </h2>
                      <h4>Equipment</h4>
                    </Card.Body>
                  </Card>
                </div>
              </React.Fragment>
            )}
          </div>
        </span>
      </div>
    </div>
  );
};

export default DashboardBoxes;
